export default __webpack_public_path__ + "static/media/Tunic of the Strange Beyond.a9b3dc56.jpg";